module.exports = __webpack_public_path__ + "static/media/logo.4607a2e3.png";